import { Box, CircularProgress } from "@mui/material";

export const LoadingSpinner = () => {
  return (
    <Box display="flex" justifyContent="center">
      <CircularProgress sx={{ marginY: "25vh" }} />
    </Box>
  );
};
